import React from "react";
import { convertDate } from "../../../utils/generalLiveCenter";
const PlayerMatches = ({ dictionary = {}, data }) => {
  const statLabels = [
    { symbol: "OPP", fullForm: "Opposite Team" },
    { symbol: "FC", fullForm: "Fouls Committed" },
    { symbol: "FA", fullForm: "Fouls Suffered" },
    { symbol: "OF", fullForm: "Offsides" },
    { symbol: "YC", fullForm: "Yellow Cards" },
    { symbol: "RC", fullForm: "Red Cards" },
  ];
  const getMatchOutcomeClass = (outcome) => {
    let outcomeClass;

    if (outcome === "W") {
      outcomeClass = "win";
    } else if (outcome === "L") {
      outcomeClass = "loss";
    } else {
      outcomeClass = "draw";
    }

    return outcomeClass;
  };
  return (
    <div className="global_table player_matches_tbl">
      <table>
        <thead>
          <tr>
            <th>{dictionary?.date || "Date"}</th>
            <th>{dictionary?.opp || "Opp"}</th>
            <th className="team">{dictionary?.results || "Results"}</th>
            <th>YC</th>
            <th>RC</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((match, index) => (
            <tr key={index}>
              <td>{convertDate(match?.dt)}</td>
              <td>
                <strong className="cr_name">{match?.oppt}</strong>
              </td>
              <td>
                <div className="result">
                  <div
                    className={`icon_status ${getMatchOutcomeClass(
                      match?.type
                    )}`}
                  >
                    <span>{match?.type}</span>
                  </div>
                  <span>{match?.ft}</span>
                </div>
              </td>
              <td>{match?.yc}</td>
              <td>{match?.rc}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="bottom_tr">
        <ul className="item_list">
          {statLabels?.map((item, index) => (
            <li key={index}>
              <span className="symbol">{item.symbol}</span>
              <span className="full-form">{item.fullForm}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PlayerMatches;
